import { cn } from "src/lib/utils";

export default function DottedLine({ color }: { color?: string }) {
  return (
    <div className="min-h-full flex flex-col items-center">
      <div
        className={cn(
          color ? `bg-${color}` : "bg-primary",
          "rounded-full w-[20px] h-[20px]"
        )}
      ></div>
      <div
        className={cn(
          `border-l-${color ?? "secondary"}`,
          "border-l-[3px] border-dashed flex-1"
        )}
      ></div>
    </div>
  );
}
